import React, {useEffect, useState} from "react";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import checkDeviceType from "../../../checkDeviceType";
import ActivityIndicator from "../../../components/ActivityIndicator";
import AdminCard from "../../../components/AdminCard";
import ListOptions from "../../../components/ListOptions";
import MainView from "../../../components/MainView";
import NavHistory from "../../../components/NavHistory";
import Notice from "../../../components/Notice";
import SearchBar from "../../../components/SearchBar";
import accessServices from "../../../services/accessServices";
import AccessCard from "./AccessCard";

import "./styles.css";


export default function AdminAccessesPage(props) {
    const [accesses, setAccesses] = useState([]);
    const [accessesToShow, setAccessesToShow] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [deviceType, setDeviceType] = useState(checkDeviceType());
    const [searchText, setSearchText] = useState("");
    const [activeOption, setActiveOption] = useState(0);
    const _id = localStorage.getItem("_id");

    function searchAccess() {
        setAccessesToShow(
            accessesToShow.filter(
                obj => obj.nome
                .toLowerCase()
                .includes(searchText.toLowerCase())
            )
        )
    }

    async function getAccesses() {
        setFetching(true);
        try {
            console.log(_id);
            const response = await accessServices.getAccessesInfos();
            setAccesses(response.data.filter(obj => obj.id != _id));
        } catch(err) {
            alert(err.message);
        }
        setFetching(false);
    }

    async function onDelete(id) {
        try {
            // eslint-disable-next-line no-restricted-globals
            if (confirm(`Deseja remover este acesso?`)) {
                const response = await accessServices.deleteAccess(id);
                setAccesses(accesses.filter(obj => obj.id !== id));
            }
        } catch(err) {
            alert("Erro ao deletar a acesso.");
        }
    }

    function onDisableAccess(index) {
        const indexOf = accesses.indexOf(accessesToShow[index]);
        setAccesses(originalArray => {
            let temp = [...originalArray];
            temp[indexOf].user.ativo = false;
            return temp;
        });
    }

    function onActivateAccess(index) {
        const indexOf = accesses.indexOf(accessesToShow[index]);
        setAccesses(originalArray => {
            let temp = [...originalArray];
            temp[indexOf].user.ativo = true;
            return temp;
        });
    }

    async function disableAccess(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja desativar o acesso de ${nome}?`)) {
            const response = await accessServices.disableAccess(id);
            if (response.status === 200) {
                onDisableAccess(index);
                console.log(`Acesso de ${nome} desativado!`);
            } else
                alert("Erro ao desativar acesso, tente novamente!");
        }
    }

    async function activateAccess(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja ativar o acesso de ${nome}?`)) {
            const response = await accessServices.activateAccess(id);
            if (response.status === 200) {
                onActivateAccess(index);
                console.log(`Acessp de ${nome} ativado!`);
            } else
                alert("Erro ao ativar acesso, tente novamente!");
        }
    }

    function filterAccesses(actives = activeOption, array = accesses) {
        let auxList = array;


        // eslint-disable-next-line default-case
        switch (actives) {
            case 1:
                auxList = auxList.filter((item) => item.user.ativo === true);
                break;
            case 2:
                auxList = auxList.filter((item) => item.user.ativo === false);
                break;
        }


        setAccessesToShow(auxList);
    }

    useEffect(() => {
        getAccesses();
        window.addEventListener('resize', () => {
            setDeviceType(checkDeviceType());
        });
    }, [])
    useEffect(() => {
        setAccessesToShow(accesses);
    }, [accesses]);

    useEffect(() => {
        filterAccesses();
    }, [activeOption]);


    return (
        <MainView
            adminMenu
            currentPage="accesses"
        >
            <NavHistory
                navPages={['Acessos']}
            />

            <div className="accesses-page-header-container">
                <div>
                    <SearchBar
                        placeholder={deviceType === 'phone' ? "Nome do acesso" : "Digite o nome do acesso"}
                        onChange={(event) => {
                            setSearchText(event.target.value);
                            if (event.target.value === "")
                                setAccessesToShow(accesses);
                        }}
                        value={searchText}
                        onClick={() => searchAccess()}
                    />

                    <Link className="button" to='/admin/novo-acesso'>
                        Nova acesso <FaPlus/>
                    </Link>
                </div>
                <div className="accesses-page-header-info">
                    <ListOptions
                        title='Status'
                        options={["Todos", "Ativos", "Inativos"]}
                        setOptionInfos={setActiveOption}
                        optionInfos={activeOption}
                    />
                <span>Exibindo {accessesToShow.length} {accessesToShow.length === 1 ? "acesso" : "acessos"}</span>


                </div>
            </div>
            <div>
                {
                    !fetching ?
                    <ul className="accesses-page-list">
                        {
                            accessesToShow.map((obj, idx) => {
                                return (

                                    <AdminCard
                                        obj={obj}
                                        foto={obj.foto}
                                        nome={obj.nome}
                                        key={idx}
                                        onActivate={() => activateAccess(idx, obj.id, obj.nome)}
                                        onDisable={() => disableAccess(idx, obj.id, obj.nome)}
                                        active={obj.user.ativo}
                                        little={deviceType === 'phone'}
                                        linkInfo={`/admin/acessos/${obj.id}`}

                                        onEditPassword={accessServices.patchAccessPassword}


                                    />
                                )
                            })
                        }
                    </ul>
                    :
                    <ActivityIndicator/>
                }



            </div>

        </MainView>
    )

}